module.exports = __webpack_public_path__ + "a951704709fff26d6d6f1cd04c649872.png";